import { GetterTree } from "vuex";
import { IDocumentConstructorState } from "@/store/modules/documentConstructor/state";
import { DocumentConstructor } from "@/types";

import { IDataProvider, IRootState } from "@/store";

export enum DocumentConstructorGetters {
  GET_ALL = "GET_ALL_DOCUMENT_CONSTRUCTOR",
  GET_CURRENT = "GET_CURRENT_DOCUMENT_CONSTRUCTOR",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_DOCUMENT_CONSTRUCTOR",
}

export const getters: GetterTree<IDocumentConstructorState, IRootState> = {
  [DocumentConstructorGetters.GET_ALL](state): DocumentConstructor[] | null {
    return state.documentConstructors;
  },
  [DocumentConstructorGetters.GET_CURRENT](state): DocumentConstructor | null {
    return state.documentConstructor;
  },
  [DocumentConstructorGetters.GET_DATA_PROVIDER](
    state
  ): IDataProvider<DocumentConstructor> | null {
    return state.dataProvider;
  },
};
